// Handles subscription box option selection
class SubscriptionOptions {
  constructor() {
    this.form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!this.form) return;

    this.optionsContainer = document.querySelector('.subscription-options');
    if (!this.optionsContainer) return;

    this.validator = new SubscriptionValidator(this.form);
    this.initializeOptions();
  }

  initializeOptions() {
    this.optionsContainer.addEventListener('change', (e) => {
      if (!e.target.matches('.radio-input')) return;

      const fieldset = e.target.closest('.option-group');
      const type = fieldset.dataset.optionType;
      const value = e.target.value;

      // Update hidden input
      const input = this.form.querySelector(`[name="properties[${type}]"]`);
      if (input) {
        input.value = value;
      }

      // Update validator
      this.validator.updateSelection(type, value);
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new SubscriptionOptions());
} else {
  new SubscriptionOptions();
}